import { axios, Response } from '../index'

export const deleteTaskComment = (taskCommentId: string): Response<null> => {
  return axios.delete(`/v1/tasks/comments/${taskCommentId}`)
}
